module.exports = __webpack_public_path__ + "img/journey-map.635cbc5e.png";